import MacStageLabel from './MacStageLabel';
import './MacStageLabel.scss';

export default MacStageLabel;